<template>
  <div class="header">
    <div class="indian-art"></div>
    <router-link
      tag="div"
      :to="{ path: '/' + $route.params.lang + '/nav/services' }"
    >
      <img class="logo" src="../assets/img/LOVAL-Logo.svg" />
    </router-link>
    <div class="slideshow">
      <div
        v-for="(img, i) in imgs"
        :key="img"
        class="slide"
        :class="imgCount === i ? 'fade' : 'hide'"
        :style="{ backgroundImage: 'url(' + img + ')' }"
      ></div>
    </div>
    <div class="nav-btn-container">
      <router-link
        tag="div"
        class="lang-btn"
        :to="{
          path:
            '/' + lang + '/' + $route.params.type + '/' + $route.params.content
        }"
      >
        <img class="lang" :src="langLogoUrl" />
      </router-link>
      <router-link
        tag="div"
        class="nav-btn"
        v-for="nav in navs"
        :key="nav.name"
        :to="{ path: '/' + $route.params.lang + '/nav/' + nav.name }"
        >{{ nav.title }}</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "loval-header",
  props: ["navs"],
  data() {
    return {
      imgNames: [
        "header_01.png",
        "electric.jpg",
        "mechanic.jpg",
        "measure.jpg"
      ],
      imgs: [],
      imgCount: 0,
      langLogoUrl: ""
    };
  },
  created() {
    this.imgNames.forEach(imgName => {
      this.imgs.push(require("../assets/img/" + imgName));
    });
    this.slideshow();
  },
  computed: {
    lang() {
      switch (this.$route.params.lang) {
        case "ES":
          this.langLogoUrl = require("../assets/img/lang_en.png");
          return "EN";
          break;
        case "DE":
          this.langLogoUrl = require("../assets/img/lang_en.png");
          return "EN";
          break;
        default:
          this.langLogoUrl = require("../assets/img/lang_es.png");
          return "ES";
      }
    }
  },
  methods: {
    slideshow() {
      let time;
      time = this.imgCount === 0 ? 5000 : 2000;
      setTimeout(() => {
        this.imgCount >= this.imgNames.length - 1
          ? (this.imgCount = 0)
          : this.imgCount++;
        this.slideshow();
      }, time);
    }
  }
};
</script>
<style scoped>
.header {
  height: var(--header-height);
  position: relative;
}
.indian-art {
  height: var(--header-indianart-height);
  background-image: url(../assets/img/IndiArt_01.png);
  background-size: cover;
  background-position-y: center;
}
.logo {
  width: 150px;
  cursor: pointer;
  position: absolute;
  top: calc(var(--header-indianart-height) + 5px);
  left: 5px;
}
.nav-btn-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(calc(-50% + (var(--header-indianart-height) / 2)));
}
.lang-btn img {
  height: 30px;
  padding-right: 16px;
}
.nav-btn {
  background-color: #00000047;
  color: var(--white);
  cursor: pointer;
  padding: 2px 16px;
  margin-bottom: 2px;
}
.nav-btn:hover {
  background-color: #ddd;
}
.router-link-active {
  background-color: #76acc4;
}
.lang-btn {
  cursor: pointer;
}
.slideshow {
  top: var(--header-indianart-height);
  position: absolute;
  height: calc(100% - var(--header-indianart-height));
  left: 0;
  width: 100%;
  z-index: -1;
}
.hide {
  display: none;
}
.fade {
  animation-name: fade;
  animation-duration: 1.5s;
}
@keyframes fade {
  from {
    opacity: 0.4;
  }
  to {
    opacity: 1;
  }
}
.slide {
  height: 100%;
  background-position: center;
  background-size: cover;
}
@media only screen and (min-width: 576px) {
  .logo {
    width: 200px;
    top: 50%;
    transform: translateY(calc(-50% + (var(--header-indianart-height) / 2)));
  }
}
@media only screen and (min-width: 1200px) {
  .logo {
    width: 300px;
    top: 50%;
    transform: translateY(calc(-50% + (var(--header-indianart-height) / 2)));
    left: 30px;
  }
  .nav-btn-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    top: var(--header-indianart-height);
    left: 0;
    transform: unset;
    background: var(--dark-blue);
    height: 45px;
    padding-left: var(--nav-width);
  }
  .nav-btn {
    height: 45px;
    background-color: unset;
    color: var(--white);
    cursor: pointer;
    padding: 0px 16px;
    margin-bottom: 0px;
    display: flex;
    align-items: center;
  }
  .router-link-active {
    background-color: #76acc4;
  }
  .lang-btn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
